import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAppFlag = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "var(--icon-size, currentSize)",
	height: "var(--icon-size, currentSize)",
	viewBox: "0 0 21 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.88965 15.1099V6.08438H11.3863L11.6085 7.19521H14.6655V12.194H11.2797L11.0575 11.0831H7.72277V15.1099H6.88965ZM11.9717 11.3608H13.8324V8.02834H10.9164L10.6943 6.91751H7.72277V10.25H11.7495L11.9717 11.3608Z",
		fill: "currentColor"
	})
});
export default SvgAppFlag;
